// AUTO-GENERATED, do not edit
// It's a TypeScript wrapper for a NftItem contract in Tolk.
/* eslint-disable */
import * as c from '@ton/core';
import { beginCell } from '@ton/core';
function makeCellFrom(self, storeFn_T) {
    let b = beginCell();
    storeFn_T(self, b);
    return b.endCell();
}
function loadAndCheckPrefix32(s, expected, structName) {
    let prefix = s.loadUint(32);
    if (prefix !== expected) {
        throw new Error(`Incorrect prefix for '${structName}': expected 0x${expected.toString(16).padStart(8, '0')}, got 0x${prefix.toString(16).padStart(8, '0')}`);
    }
}
function formatPrefix(prefixNum, prefixLen) {
    return prefixLen % 4 ? `0b${prefixNum.toString(2).padStart(prefixLen, '0')}` : `0x${prefixNum.toString(16).padStart(prefixLen / 4, '0')}`;
}
function loadAndCheckPrefix(s, expected, prefixLen, structName) {
    let prefix = s.loadUint(prefixLen);
    if (prefix !== expected) {
        throw new Error(`Incorrect prefix for '${structName}': expected ${formatPrefix(expected, prefixLen)}, got ${formatPrefix(prefix, prefixLen)}`);
    }
}
function lookupPrefix(s, expected, prefixLen) {
    return s.remainingBits >= prefixLen && s.preloadUint(prefixLen) === expected;
}
function throwNonePrefixMatch(fieldPath) {
    throw new Error(`Incorrect prefix for '${fieldPath}': none of variants matched`);
}
function storeCellRef(cell, b, storeFn_T) {
    let b_ref = c.beginCell();
    storeFn_T(cell.ref, b_ref);
    b.storeRef(b_ref.endCell());
}
function loadCellRef(s, loadFn_T) {
    let s_ref = s.loadRef().beginParse();
    return { ref: loadFn_T(s_ref) };
}
function storeTolkRemaining(v, b) {
    b.storeSlice(v);
}
function loadTolkRemaining(s) {
    let rest = s.clone();
    s.loadBits(s.remainingBits);
    while (s.remainingRefs) {
        s.loadRef();
    }
    return rest;
}
function storeTolkNullable(v, b, storeFn_T) {
    if (v === null) {
        b.storeUint(0, 1);
    }
    else {
        b.storeUint(1, 1);
        storeFn_T(v, b);
    }
}
// ————————————————————————————————————————————
//   parse get methods result from a TVM stack
//
class StackReader {
    tuple;
    constructor(tuple) {
        this.tuple = tuple;
    }
    static fromGetMethod(expectedN, getMethodResult) {
        let tuple = [];
        while (getMethodResult.stack.remaining) {
            tuple.push(getMethodResult.stack.pop());
        }
        if (tuple.length !== expectedN) {
            throw new Error(`expected ${expectedN} stack width, got ${tuple.length}`);
        }
        return new StackReader(tuple);
    }
    popExpecting(itemType) {
        const item = this.tuple.shift();
        if (item?.type === itemType) {
            return item;
        }
        throw new Error(`not '${itemType}' on a stack`);
    }
    popCellLike() {
        const item = this.tuple.shift();
        if (item && (item.type === 'cell' || item.type === 'slice' || item.type === 'builder')) {
            return item.cell;
        }
        throw new Error(`not cell/slice on a stack`);
    }
    readBigInt() {
        return this.popExpecting('int').value;
    }
    readBoolean() {
        return this.popExpecting('int').value !== 0n;
    }
    readCell() {
        return this.popCellLike();
    }
    readSlice() {
        return this.popCellLike().beginParse();
    }
    readSnakeString() {
        return this.readCell().beginParse().loadStringTail();
    }
    readNullable(readFn_T) {
        if (this.tuple[0].type === 'null') {
            this.tuple.shift();
            return null;
        }
        return readFn_T(this);
    }
}
export const RequestReveal = {
    PREFIX: 0xf000001c,
    create(args) {
        return {
            $: 'RequestReveal',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0xf000001c, 'RequestReveal');
        return {
            $: 'RequestReveal',
            queryId: s.loadUintBig(64),
        };
    },
    store(self, b) {
        b.storeUint(0xf000001c, 32);
        b.storeUint(self.queryId, 64);
    },
    toCell(self) {
        return makeCellFrom(self, RequestReveal.store);
    }
};
export const RequestRevealContent = {
    PREFIX: 0xf000001e,
    create(args) {
        return {
            $: 'RequestRevealContent',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0xf000001e, 'RequestRevealContent');
        return {
            $: 'RequestRevealContent',
            queryId: s.loadUintBig(64),
            itemIndex: s.loadUintBig(256),
        };
    },
    store(self, b) {
        b.storeUint(0xf000001e, 32);
        b.storeUint(self.queryId, 64);
        b.storeUint(self.itemIndex, 256);
    },
    toCell(self) {
        return makeCellFrom(self, RequestRevealContent.store);
    }
};
export const UpdateContent = {
    PREFIX: 0xf000001d,
    create(args) {
        return {
            $: 'UpdateContent',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0xf000001d, 'UpdateContent');
        return {
            $: 'UpdateContent',
            queryId: s.loadUintBig(64),
            newContent: s.loadStringRefTail(),
        };
    },
    store(self, b) {
        b.storeUint(0xf000001d, 32);
        b.storeUint(self.queryId, 64);
        b.storeStringRefTail(self.newContent);
    },
    toCell(self) {
        return makeCellFrom(self, UpdateContent.store);
    }
};
export const NftRevealedEvent = {
    PREFIX: 0xf000f052,
    create(args) {
        return {
            $: 'NftRevealedEvent',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0xf000f052, 'NftRevealedEvent');
        return {
            $: 'NftRevealedEvent',
            itemIndex: s.loadUintBig(256),
            ownerAddress: s.loadAddress(),
            revealedAt: s.loadUintBig(64),
        };
    },
    store(self, b) {
        b.storeUint(0xf000f052, 32);
        b.storeUint(self.itemIndex, 256);
        b.storeAddress(self.ownerAddress);
        b.storeUint(self.revealedAt, 64);
    },
    toCell(self) {
        return makeCellFrom(self, NftRevealedEvent.store);
    }
};
export const RequestStaticData = {
    PREFIX: 0x2fcb26a2,
    create(args) {
        return {
            $: 'RequestStaticData',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0x2fcb26a2, 'RequestStaticData');
        return {
            $: 'RequestStaticData',
            queryId: s.loadUintBig(64),
        };
    },
    store(self, b) {
        b.storeUint(0x2fcb26a2, 32);
        b.storeUint(self.queryId, 64);
    },
    toCell(self) {
        return makeCellFrom(self, RequestStaticData.store);
    }
};
export const ResponseStaticData = {
    PREFIX: 0x8b771735,
    create(args) {
        return {
            $: 'ResponseStaticData',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0x8b771735, 'ResponseStaticData');
        return {
            $: 'ResponseStaticData',
            queryId: s.loadUintBig(64),
            itemIndex: s.loadUintBig(256),
            collectionAddress: s.loadAddress(),
        };
    },
    store(self, b) {
        b.storeUint(0x8b771735, 32);
        b.storeUint(self.queryId, 64);
        b.storeUint(self.itemIndex, 256);
        b.storeAddress(self.collectionAddress);
    },
    toCell(self) {
        return makeCellFrom(self, ResponseStaticData.store);
    }
};
export const PayloadInline = {
    PREFIX: 0b0,
    create(args) {
        return {
            $: 'PayloadInline',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix(s, 0b0, 1, 'PayloadInline');
        return {
            $: 'PayloadInline',
            value: loadTolkRemaining(s),
        };
    },
    store(self, b) {
        b.storeUint(0b0, 1);
        storeTolkRemaining(self.value, b);
    },
    toCell(self) {
        return makeCellFrom(self, PayloadInline.store);
    }
};
export const PayloadInRef = {
    PREFIX: 0b1,
    create(args) {
        return {
            $: 'PayloadInRef',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix(s, 0b1, 1, 'PayloadInRef');
        return {
            $: 'PayloadInRef',
            value: loadCellRef(s, loadTolkRemaining),
        };
    },
    store(self, b) {
        b.storeUint(0b1, 1);
        storeCellRef(self.value, b, storeTolkRemaining);
    },
    toCell(self) {
        return makeCellFrom(self, PayloadInRef.store);
    }
};
export const NotificationForNewOwner = {
    PREFIX: 0x05138d91,
    create(args) {
        return {
            $: 'NotificationForNewOwner',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0x05138d91, 'NotificationForNewOwner');
        return {
            $: 'NotificationForNewOwner',
            queryId: s.loadUintBig(64),
            oldOwnerAddress: s.loadAddress(),
            payload: lookupPrefix(s, 0b0, 1) ? PayloadInline.fromSlice(s) :
                lookupPrefix(s, 0b1, 1) ? PayloadInRef.fromSlice(s) :
                    throwNonePrefixMatch('NotificationForNewOwner.payload'),
        };
    },
    store(self, b) {
        b.storeUint(0x05138d91, 32);
        b.storeUint(self.queryId, 64);
        b.storeAddress(self.oldOwnerAddress);
        switch (self.payload.$) {
            case 'PayloadInline':
                PayloadInline.store(self.payload, b);
                break;
            case 'PayloadInRef':
                PayloadInRef.store(self.payload, b);
                break;
        }
    },
    toCell(self) {
        return makeCellFrom(self, NotificationForNewOwner.store);
    }
};
export const ReturnExcessesBack = {
    PREFIX: 0xd53276db,
    create(args) {
        return {
            $: 'ReturnExcessesBack',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0xd53276db, 'ReturnExcessesBack');
        return {
            $: 'ReturnExcessesBack',
            queryId: s.loadUintBig(64),
        };
    },
    store(self, b) {
        b.storeUint(0xd53276db, 32);
        b.storeUint(self.queryId, 64);
    },
    toCell(self) {
        return makeCellFrom(self, ReturnExcessesBack.store);
    }
};
export const AskToChangeOwnership = {
    PREFIX: 0x5fcc3d14,
    create(args) {
        return {
            $: 'AskToChangeOwnership',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0x5fcc3d14, 'AskToChangeOwnership');
        return {
            $: 'AskToChangeOwnership',
            queryId: s.loadUintBig(64),
            newOwnerAddress: s.loadAddress(),
            sendExcessesTo: s.loadMaybeAddress(),
            customPayload: s.loadBoolean() ? s.loadRef() : null,
            forwardTonAmount: s.loadCoins(),
            forwardPayload: lookupPrefix(s, 0b0, 1) ? PayloadInline.fromSlice(s) :
                lookupPrefix(s, 0b1, 1) ? PayloadInRef.fromSlice(s) :
                    throwNonePrefixMatch('AskToChangeOwnership.forwardPayload'),
        };
    },
    store(self, b) {
        b.storeUint(0x5fcc3d14, 32);
        b.storeUint(self.queryId, 64);
        b.storeAddress(self.newOwnerAddress);
        b.storeAddress(self.sendExcessesTo);
        storeTolkNullable(self.customPayload, b, (v, b) => b.storeRef(v));
        b.storeCoins(self.forwardTonAmount);
        switch (self.forwardPayload.$) {
            case 'PayloadInline':
                PayloadInline.store(self.forwardPayload, b);
                break;
            case 'PayloadInRef':
                PayloadInRef.store(self.forwardPayload, b);
                break;
        }
    },
    toCell(self) {
        return makeCellFrom(self, AskToChangeOwnership.store);
    }
};
export const NftItemStorage = {
    create(args) {
        return {
            $: 'NftItemStorage',
            ...args
        };
    },
    fromSlice(s) {
        return {
            $: 'NftItemStorage',
            itemIndex: s.loadUintBig(64),
            collectionAddress: s.loadAddress(),
            ownerAddress: s.loadAddress(),
            content: s.loadStringRefTail(),
            isSoulbound: s.loadBoolean(),
            isRevealed: s.loadBoolean(),
            revealedAt: s.loadUintBig(64),
        };
    },
    store(self, b) {
        b.storeUint(self.itemIndex, 64);
        b.storeAddress(self.collectionAddress);
        b.storeAddress(self.ownerAddress);
        b.storeStringRefTail(self.content);
        b.storeBit(self.isSoulbound);
        b.storeBit(self.isRevealed);
        b.storeUint(self.revealedAt, 64);
    },
    toCell(self) {
        return makeCellFrom(self, NftItemStorage.store);
    }
};
export const NftItemStorageNotInitialized = {
    create(args) {
        return {
            $: 'NftItemStorageNotInitialized',
            ...args
        };
    },
    fromSlice(s) {
        return {
            $: 'NftItemStorageNotInitialized',
            itemIndex: s.loadUintBig(64),
            collectionAddress: s.loadAddress(),
        };
    },
    store(self, b) {
        b.storeUint(self.itemIndex, 64);
        b.storeAddress(self.collectionAddress);
    },
    toCell(self) {
        return makeCellFrom(self, NftItemStorageNotInitialized.store);
    }
};
export const NftDataReply = {
    create(args) {
        return {
            $: 'NftDataReply',
            ownerAddress: null,
            content: null,
            ...args
        };
    },
    fromSlice(s) {
        throw new Error(`Can't unpack 'NftDataReply' from cell, because 'NftDataReply.itemIndex' is 'int' (not int32/uint64/etc.)`);
    },
    store(self, b) {
        throw new Error(`Can't pack 'NftDataReply' to cell, because 'self.itemIndex' is 'int' (not int32/uint64/etc.)`);
    },
    toCell(self) {
        return makeCellFrom(self, NftDataReply.store);
    }
};
export const NftExtendedDataReply = {
    create(args) {
        return {
            $: 'NftExtendedDataReply',
            ...args
        };
    },
    fromSlice(s) {
        throw new Error(`Can't unpack 'NftExtendedDataReply' from cell, because 'NftExtendedDataReply.revealedAt' is 'int' (not int32/uint64/etc.)`);
    },
    store(self, b) {
        throw new Error(`Can't pack 'NftExtendedDataReply' to cell, because 'self.revealedAt' is 'int' (not int32/uint64/etc.)`);
    },
    toCell(self) {
        return makeCellFrom(self, NftExtendedDataReply.store);
    }
};
function calculateDeployedAddress(code, data, options) {
    const stateInitCell = beginCell().store(c.storeStateInit({
        code,
        data,
        splitDepth: options.toShard?.fixedPrefixLength,
        special: null,
        libraries: null,
    })).endCell();
    let addrHash = stateInitCell.hash();
    if (options.toShard) {
        const shardDepth = options.toShard.fixedPrefixLength;
        addrHash = beginCell()
            .storeBits(new c.BitString(options.toShard.closeTo.hash, 0, shardDepth))
            .storeBits(new c.BitString(stateInitCell.hash(), shardDepth, 256 - shardDepth))
            .endCell()
            .beginParse().loadBuffer(32);
    }
    return new c.Address(options.workchain ?? 0, addrHash);
}
export class NftItem {
    static CodeCell = c.Cell.fromBase64('te6ccgECFQEAAoIAART/APSkE/S88sgLAQIBYgIDBNjQ+JGRMODtRNDTP/pIIMcAjikw+JIhxwXy4ZUC+kjU0gDSANEEyMs/FfpSEvpSzBLKAMoAcM8LP8ntVOD6SNTSANIA1ws/J9csIv5h6KTjAjEzAtcsIX5ZNRTjAtcsJ4AAAOTjAtcsJ4AAAOwEBQYHAgEgCwwD/jj4kiXHBfLhkSLy0ZoH0z/6SPpQ9AH6ACDXSyHy4sQi1wsAnwHAAZTAAcMAkjBw4vLixJFb4iP6RDDy0U34k3D4OvgnbxCCCvrwgKEjlFMxoKHeJG6RMZgk+kQw8tFNouIgwv/y4ZIikjlb4w0gbpMwNTDjDgXIyz8U+lIS+lIICQoARjZfAwLXCz/4ksjPhQj6UoIQi3cXNc8Ljss/y//6UsmAQPsAAFYxNfiSWMcF8uGR8tGbAtcLP8jPhQgT+lKCEPAAAB7PC44Syz/L/8mAQPsAALCOTDb4kiTHBfLhlQHy0ZsE10z4IyTIyz8U+lJSIPpSzBTKAM+DIc8LP8ntVIsCyM+TwAPBShPL/xP6UhLLP8nIz4cgEs5xzwthzMlw+wDgXwaEDwHHAPL0AEjIz5AUTjZGJs8LPxr6Us7JyM+FCFJA+lJY+gJxzwtqzMlx+wAAMsjPhQj6UlAG+gKCENUydtvPC4rLP8lx+wAAFMzKAMoAyz/J7VQCASANDgIBIA8QAB27ml7UTQ0z8x+kgx+kgwgAEbunvtRNDXCz+AIBYhESAgEgExQAMawvdqJoaZ+Y/SQY/SQY6hjpAGkAa4WfiUAANa/n9qJoaZ/9JBBjgEqYOCy2tvB9JGumP6qYQAAHtGfucAAXtq+9qJoaZ+Y/SQYQ');
    static Errors = {
        'Errors.InvalidWorkchain': 333,
        'Errors.NotFromOwner': 401,
        'Errors.TooSmallRestAmount': 402,
        'Errors.NotFromCollection': 405,
        'Errors.Soulbound': 410,
        'Errors.AlreadyRevealed': 411,
        'Errors.IncorrectForwardPayload': 708,
    };
    address;
    init;
    constructor(address, init) {
        this.address = address;
        this.init = init;
    }
    static fromAddress(address) {
        return new NftItem(address);
    }
    static fromStorage(emptyStorage, deployedOptions) {
        const initialState = {
            code: deployedOptions?.overrideContractCode ?? NftItem.CodeCell,
            data: NftItemStorageNotInitialized.toCell(NftItemStorageNotInitialized.create(emptyStorage)),
        };
        const address = calculateDeployedAddress(initialState.code, initialState.data, deployedOptions ?? {});
        return new NftItem(address, initialState);
    }
    static createCellOfAskToChangeOwnership(body) {
        return AskToChangeOwnership.toCell(AskToChangeOwnership.create(body));
    }
    static createCellOfRequestStaticData(body) {
        return RequestStaticData.toCell(RequestStaticData.create(body));
    }
    static createCellOfRequestReveal(body) {
        return RequestReveal.toCell(RequestReveal.create(body));
    }
    static createCellOfUpdateContent(body) {
        return UpdateContent.toCell(UpdateContent.create(body));
    }
    async sendDeploy(provider, via, msgValue, extraOptions) {
        return provider.internal(via, {
            value: msgValue,
            body: c.Cell.EMPTY,
            ...extraOptions
        });
    }
    async sendAskToChangeOwnership(provider, via, msgValue, body, extraOptions) {
        return provider.internal(via, {
            value: msgValue,
            body: AskToChangeOwnership.toCell(AskToChangeOwnership.create(body)),
            ...extraOptions
        });
    }
    async sendRequestStaticData(provider, via, msgValue, body, extraOptions) {
        return provider.internal(via, {
            value: msgValue,
            body: RequestStaticData.toCell(RequestStaticData.create(body)),
            ...extraOptions
        });
    }
    async sendRequestReveal(provider, via, msgValue, body, extraOptions) {
        return provider.internal(via, {
            value: msgValue,
            body: RequestReveal.toCell(RequestReveal.create(body)),
            ...extraOptions
        });
    }
    async sendUpdateContent(provider, via, msgValue, body, extraOptions) {
        return provider.internal(via, {
            value: msgValue,
            body: UpdateContent.toCell(UpdateContent.create(body)),
            ...extraOptions
        });
    }
    async getNftData(provider) {
        const r = StackReader.fromGetMethod(5, await provider.get('get_nft_data', []));
        return ({
            $: 'NftDataReply',
            isInitialized: r.readBoolean(),
            itemIndex: r.readBigInt(),
            collectionAddress: r.readSlice().loadAddress(),
            ownerAddress: r.readNullable((r) => r.readSlice().loadAddress()),
            content: r.readNullable((r) => r.readSnakeString()),
        });
    }
    async getExtendedItemData(provider) {
        const r = StackReader.fromGetMethod(3, await provider.get('get_extended_item_data', []));
        return ({
            $: 'NftExtendedDataReply',
            isRevealed: r.readBoolean(),
            isSoulbound: r.readBoolean(),
            revealedAt: r.readBigInt(),
        });
    }
    async getAbiVersion(provider) {
        const r = StackReader.fromGetMethod(1, await provider.get('get_abi_version', []));
        return r.readBigInt();
    }
    async getOwner(provider) {
        const r = StackReader.fromGetMethod(1, await provider.get('get_owner', []));
        return r.readSlice().loadAddress();
    }
    async getIndex(provider) {
        const r = StackReader.fromGetMethod(1, await provider.get('get_index', []));
        return r.readBigInt();
    }
    async getCollection(provider) {
        const r = StackReader.fromGetMethod(1, await provider.get('get_collection', []));
        return r.readSlice().loadAddress();
    }
}
